import React from "react";
import { motion } from "framer-motion";
import {
  BadgeCheck,
  Cpu,
  HeadphonesIcon,
  Layers,
  Settings2,
  Timer,
  Sparkles,
} from "lucide-react";

const FEATURES = [
  {
    Icon: BadgeCheck,
    title: "Quality Manufacturing",
    text:
      "Every unit passes 100 %QC checkpoints before dispatch — CRGO cores, copper windings, and premium electronics.",
  },
  {
    Icon: Cpu,
    title: "Latest Technology",
    text:
      "Microcontroller-based control cards, IGBT switching options across the range.",
  },
  {
    Icon: HeadphonesIcon,
    title: "Prompt Customer Support",
    text:
      "In-house support engineers with average response time under 4 hours. Nationwide service network.",
  },
  {
    Icon: Layers,
    title: "Customized Solutions",
    text:
      "Bespoke ratings, enclosures and voltage windows for your specific load and environment.",
  },

  {
    Icon: Sparkles,
    title: "Reliable Performance",
    text:
      "3 to 5-year comprehensive warranty on all products, backed by 20+ years of field data.",
  },
];

export function WhyChoose() {
  return (
    <section className="bg-white py-24" data-testid="why-choose-section">
      <div className="container-wide">
        <div className="max-w-3xl mb-14">
          <div className="section-label mb-4">Why Choose Vortex</div>
          <h2 className="font-heading font-extrabold text-4xl md:text-5xl text-vortex-navy tracking-tighter leading-[1.05]">
            The reasons power engineers pick us over the rest.
          </h2>
        </div>

        {/* Bento grid: first card spans 2 cols on lg */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {FEATURES.map((f, i) => {
            const wide = i === 0;
            return (
              <motion.div
                key={f.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ delay: i * 0.06, duration: 0.55 }}
                className={`group relative rounded-2xl p-7 md:p-8 border border-vortex-border hover:border-vortex-blue/40 transition-colors overflow-hidden ${
                  wide
                    ? "lg:col-span-2 lg:row-span-2 bg-vortex-navy text-white"
                    : "bg-vortex-alt hover:bg-white hover:shadow-lg"
                }`}
                data-testid={`why-choose-${i}`}
              >
                {wide && (
                  <div className="absolute inset-0 grid-pattern opacity-30 pointer-events-none" />
                )}
                <div
                  className={`relative w-12 h-12 rounded-xl flex items-center justify-center mb-5 ${
                    wide
                      ? "bg-vortex-blue text-vortex-navy"
                      : "bg-white border border-vortex-border text-vortex-blue"
                  }`}
                >
                  <f.Icon className="w-5 h-5" strokeWidth={1.5} />
                </div>
                <h3
                  className={`relative font-heading font-bold text-xl md:text-2xl mb-3 leading-tight ${
                    wide ? "text-white" : "text-vortex-navy"
                  }`}
                >
                  {f.title}
                </h3>
                <p
                  className={`relative text-sm leading-relaxed ${
                    wide ? "text-white/75" : "text-vortex-slate"
                  }`}
                >
                  {f.text}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
